import { get } from 'lodash';
import { resolveIsCryptoLoan } from './cryptoUtils';

export const AUTOPAY_UNAVAILABLE_MESSAGE = 'We are unable to schedule auto\u2011pay online for this loan type. Please call us at 888\u2011502\u20118020 to discuss your auto\u2011pay options.';

export const isOnlineAutopayUnavailable = (loanTerm, loansList) => {
  const repaymentCode = String(get(loanTerm, 'data.repaymentType.code', '')).toLowerCase();
  return repaymentCode === 'no-payment' && resolveIsCryptoLoan(loansList);
};
